import React from 'react'
import PropTypes from 'prop-types'

import Toggle from 'react-toggle'
import { get } from 'lodash'

const ToggleButton = ({ input }) => {
  const checked = get(input, 'value')
  const onChange = get(input, 'onChange')

  return (
    <Toggle
      icons={false}
      checked={checked}
      onChange={onChange}
    />
  )
}

ToggleButton.defaultProps = {
  input: {
    value: true,
    onChange: () => {},
  }
}

ToggleButton.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.bool,
    onChange: PropTypes.func,
  })
}

export default ToggleButton
